export const sessionModeType = {
    UNLIMITED: 'unlimited',
    SECTION_25: 'section_25'
};
